


































































































import Vue from 'vue';
import _ from 'lodash';
import Draggable from 'vuedraggable';
import PropertyListing from './property-listing.vue';
import ButtonToggle from '@/components/common/button-toggle.vue';
import { getModule } from "vuex-module-decorators";
import DecisionModule from "@/store/decision/Decision";
import FavouritesModule from "@/store/Favourites";
import { ChoiceFactorScore, ChoiceScore } from "@/api/model/ViewpointChoiceScore";
import { Component, Prop } from "vue-property-decorator";
import { Choice } from "@/api/model/Choice";

@Component({
  components: {
    'draggable': Draggable,
    'button-toggle': ButtonToggle,
    'property-listing': PropertyListing,
  }
})
export default class PropertyResultsCardTile extends Vue {

  @Prop({
    type: Object,
    default: {} as any,
  })
  choiceProp!: Choice

  @Prop({
    type: Object,
    default: {} as any,
  })
  choiceScoresProp!: ChoiceScore;

  @Prop({
    type: Array,
    default: [] as any,
  })
  favouritesProp!: any[]

  dialog = true
  choice = this.choiceProp

  factorGroupName = 'Lifestyle'


  get sortedFactorScores() {
    return (Object.values(this.choiceScoresProp.choiceFactorScores) as ChoiceFactorScore[])
        //@ts-ignore
        .filter(cf => this.factors[cf.id].type === 'FACTOR')
        .sort((a, b) => b.weight * b.score - a.weight * a.score)
  }

  get factors() {
    return getModule(DecisionModule).factorResourceMap
  }


  dragStart() {
    // this.dragging = true;
  }

  dragEnd() {
    // this.dragging = false;
    // this.recalculateFactorWeights();
  }

  isFavourite(choiceId: string): boolean {
    //@ts-ignore
    return this.favouritesProp.includes(choiceId);
  }

  async addFavourite(choiceId: string) {
    await getModule(FavouritesModule).addFavourite(choiceId);
  }

  async removeFavourite(choiceId: string) {
    await getModule(FavouritesModule).removeFavourite(choiceId);
  }

  getPropertyValue(choice: any, name: string) {
    return choice[_.camelCase(name)]
  }

  formatNumber(value: number, digits: number = 0) {
    if (digits < 0) digits = 0;
    var formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits,
    });
    return Number(formatter.format(value));
  }


}

